import * as Sentry from "@sentry/browser";
import { browserTracingIntegration } from "@sentry/browser";

// Only initialize Sentry in production and not on locally saved files
if (process.env.USE_SENTRY === "true" && window.location.protocol !== "file:") {
  Sentry.init({
    dsn: "https://7ce75d0607bb44dab40d4e0a69069393@o435015.ingest.sentry.io/5403471",
    environment: process.env.NODE_ENV,
    release: process.env.SENTRY_RELEASE,
    integrations: [browserTracingIntegration()],
    // Magic number is an attempt to spread our Sentry quota out over the month.
    tracesSampleRate: 0.01,
    allowUrls: [/https?:\/\/(.+\.)?batchgeo.com/],
    ignoreErrors: [
      "Non-Error promise rejection captured", // Prevents a known issue with Sentry v6.x.x - Should be removed if Sentry version is updated
      "ResizeObserver loop limit exceeded", // Prevents a known issue(https://github.com/pholmstr/batchgeo/issues/3169)
      "ResizeObserver loop completed with undelivered notifications", // Prevents a known issue(https://github.com/pholmstr/batchgeo/issues/3169)
      "zaloJSV2", // Prevents an issue that does not impact logic (https://developers.zalo.me/community/detail/1425f4c0c88521db7894)
    ],
  });
}

export default Sentry;
